import { PlayerStatus } from '@tunein/web-player-manager';
import { keyMirror } from '@tunein/web-utils';
import PauseCircleSolid from 'src/common/components/shared/svgIcons/player/PauseCircleSolid';
import PlayCircleSolid from 'src/common/components/shared/svgIcons/player/PlayCircleSolid';
import StopCircleSolid from 'src/common/components/shared/svgIcons/player/StopCircleSolid';
import { playerStatuses } from 'src/common/constants/playerStatuses';

// These states should match the statuses for which we return the play icon class below
export const playIconPlayerStatuses = keyMirror(
  [playerStatuses.paused],
  [playerStatuses.stopped],
  [playerStatuses.idle],
  [playerStatuses.failed],
);

export const playerIconClasses = {
  play: 'icon-play-circle-outline',
  pause: 'icon-pause-circle-outline',
  stop: 'icon-stop-circle-outline',
};

const getPlayIcon = () => playerIconClasses.play;
const getPlaySvgIcon = () => PlayCircleSolid;

export const playerStatusToSvgIconMap = {
  [playerStatuses.playing]: (canScrub) => {
    return canScrub ? PauseCircleSolid : StopCircleSolid;
  },
  [playerStatuses.paused]: getPlaySvgIcon,
  [playerStatuses.stopped]: getPlaySvgIcon,
  [playerStatuses.idle]: getPlaySvgIcon,
  [playerStatuses.failed]: getPlaySvgIcon,
  [playerStatuses.connecting]: () => '',
  [playerStatuses.waiting]: () => '',
  [playerStatuses.recovering]: () => '',
};

export const playerManagerStatusToSvgIconMap = {
  [PlayerStatus.PLAYING]: (canScrub) => (canScrub ? PauseCircleSolid : StopCircleSolid),
  [PlayerStatus.IDLE]: getPlaySvgIcon,
  [PlayerStatus.FAILED]: getPlaySvgIcon,
  [PlayerStatus.LOADING]: () => '',
  [PlayerStatus.WAITING]: () => '',
  // Background recovery renders as a stop control where a spinner is not drawn separately —
  // the session is active and stopping it is the one meaningful action.
  [PlayerStatus.RECOVERING]: () => StopCircleSolid,
};

export const playerStatusToIconMap = {
  [playerStatuses.playing]: (canScrub) =>
    canScrub ? playerIconClasses.pause : playerIconClasses.stop,
  [playerStatuses.paused]: getPlayIcon,
  [playerStatuses.stopped]: getPlayIcon,
  [playerStatuses.idle]: getPlayIcon,
  [playerStatuses.failed]: getPlayIcon,
  [playerStatuses.connecting]: () => '',
  [playerStatuses.waiting]: () => '',
  [playerStatuses.recovering]: () => '',
  [playerStatuses.popout]: () => 'icon-popout-circle',
};

// An unmapped status (one the player gained after these maps were written) falls back to the play
// icon rather than throwing mid-render. It is the control's resting state, so it stays visible and
// clickable, and the click still goes through player.onClick, which acts on the player's real state;
// a spinner fallback could claim progress that isn't happening.
export const getPlayerStatusIcon = (playerStatus, canScrub) =>
  (playerStatusToIconMap[playerStatus] ?? getPlayIcon)(canScrub);

export const getPlayerStatusSvgIcon = (playerStatus, canScrub) =>
  (playerStatusToSvgIconMap[playerStatus] ?? getPlaySvgIcon)(canScrub);

export const getPlayerManagerStatusSvgIcon = (playerStatus, canScrub) =>
  (playerManagerStatusToSvgIconMap[playerStatus] ?? getPlaySvgIcon)(canScrub);
